import React, { useState, useEffect, useRef, memo } from 'react';
import './css/banner_card.scss';
import { useDispatch, useSelector } from 'react-redux';
import { bannerLocalConstant } from './utils';
import * as bannerUtils from './utils';
import ReactPlayer from 'react-player';
import { useLocation, useNavigate } from 'react-router';
import {
  updateReportData,
  addBannerClickReport,
  updateBannerCardIndex,
  addBannerConsentClickReport
} from '../../Store/actions';
// import useInViewport from '../customHooks/useIntersection';
import { useInView } from 'react-intersection-observer';
import ImageBannerPlayer from './ImageBannerPlayer';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import queryString from 'query-string';
import { getClientDeviceDetails, log } from '../../common/common';
import useRedirect from '../customHooks/useRedirect';
import dayjs from 'dayjs';
import appConfig from '../../config/config';
import ConsentModal from './ConsentModal';

const TARGET_TYPE_FLOATING = 'Floating';
const TARGET_TYPE_FILLER = 'Filler';
const TARGET_TYPE_FIXED = 'Fixed';
const _TARGET_BLANK = '_blank';
const _TARGET_SELF = '_self';
const _TARGET_DOWNLOAD = 'download';
const BANNER_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * @param {string} position of banner Item
 * @param {string} name of the page
 * @param {string} className of banner Item Parent
 * @return {jsx} banner creative to show
 */

const getLocalStorage = (key, defaultValue) => {
  const prodMode = appConfig.is_production_build;
  let local_data = localStorage.getItem(
    `${prodMode ? '@ClirnetStore_prod' : '@ClirnetStore_dev'}_${key}`
  );
  if (local_data) {
    return local_data;
  } else {
    return defaultValue;
  }
};

let temp_creative_id = 0;
const BannerItemCard = ({ position = '', page_name = '', customClass = '' }) => {
  let banner_card_index_data = useSelector((state) => state.banner.banner_card_index);
  const userDetails = () => (getLocalStorage('user', false) ? getLocalStorage('user', {}) : {});
  const topBannerPlayerRef = useRef(null);
  const topBannerContainer = useRef();
  const { redirectTo } = useRedirect();
  const _playing_item_ref = useRef([]);
  const _playing_index_ref = useRef(0);
  const _video_duration_ref = useRef(0);

  const { search } = useLocation();
  const { id } = queryString.parse(search);
  const [content_id, set_content_id] = useState(id ? id : 0);
  const [type, set_type] = useState(page_name ? page_name : '');
  const [top_banner_playing_index, set_top_banner_playing_index] = useState(
    banner_card_index_data > 0 ?? 0
  );
  const [top_banner_playing_item, set_top_banner_playing_item] = useState([]);
  const [platform_name, set_platform_name] = useState(bannerUtils.getPlatForm());
  const [banner_user, set_banner_user] = useState(
    JSON.parse(getLocalStorage('user', '{}'))?.user_master_id
  );
  const [top_banner_data, set_top_banner_data] = useState([]);
  const [separate_data, set_separate_data] = useState({});
  const [reRender, setReRender] = useState(true);
  const [banner_play_data, set_banner_play_data] = useState([]);
  const [banner_position, set_banner_position] = useState(position);

  const [video_duration, set_video_duration] = useState('');
  const [is_banner_allowed, set_is_banner_allowed] = useState(false);
  const [banner_setting, set_banner_setting] = useState('0x0');
  const [window_width, set_window_width] = useState(0);

  const [isHoverd, setIsHoverd] = useState(false);
  const [activeHover, setActiveHover] = useState(false);

  const [is_consent_modal, setIsConsentModal] = useState(false);
  const [consent_text, setConsentText] = useState('');
  const toggleConsentModal = (payload) => setIsConsentModal(payload);
  let videoPlay = false;
  const dispatch = useDispatch();

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };

  const [bannerDivObserver, inView] = useInView({
    fallbackInView: false,
    threshold: 0
  });

  let visibilityChange = typeof document.hidden
    ? 'visibilitychange'
    : typeof document.msHidden
    ? 'msvisibilitychange'
    : typeof document.webkitHidden
    ? 'webkitvisibilitychange'
    : 'visibilitychange';

  // geting platform list data from redux store
  let global_banner_main_data = useSelector((state) => state.banner.banner_data);

  let content_fetch_status = useSelector((state) => state.banner.content_data_get);

  // geting exclude data from redux store
  let banner_exclution_list = useSelector((state) => state.banner.banner_exclution_list);

  // geting content banner data from redux store
  let content_banner_main_data = useSelector((state) => state.banner.content_banner_data);

  // geting banner settings data from redux store
  let banner_settings_data = useSelector((state) => state.banner.banner_settings);

  // // ----------------------------
  if (inView) {
    videoPlay = true;
  } else {
    videoPlay = false;
  }
  // ----------------------------

  // visibility change observer
  useEffect(() => {
    if (topBannerContainer.current) {
      set_window_width(topBannerContainer.current.offsetWidth);
    }

    return () => {
      recordAnalytics(
        'unmount',
        _playing_item_ref.current,
        _playing_index_ref.current,
        _video_duration_ref.current
      );
    };
  }, []);

  // banner exclution data observer
  useEffect(() => {
    if (
      content_id &&
      content_id != 0 &&
      banner_exclution_list?.length > 0 &&
      bannerUtils._isContains(banner_exclution_list, 'type', page_name)
    ) {
      let exclutionList = bannerUtils.filterExclutionListByType(banner_exclution_list, page_name);
      // console.group(`checking exclutionList`)
      // //console.log(JSON.stringify(exclutionList))
      // console.groupEnd(`checking exclutionList`)
      if (exclutionList?.length > 0) {
        // //console.log("exclution length >0")
        let { ids } = exclutionList[0];

        // //console.log("ids:::" + ids.split(','))
        let excludedIds = ids ? ids.split(',') : [];

        if (excludedIds.includes(content_id)) {
          // //console.log("exclution id  avalable")
          set_is_banner_allowed(false);
          set_banner_setting('0x0');
        } else {
          // //console.log("exclution id not available")
          set_is_banner_allowed(true);
        }
      } else {
        // //console.log("exclution not length >0")
        set_is_banner_allowed(true);
      }
    } else {
      // //console.log("exclution else")
      set_is_banner_allowed(true);
    }
    return () => {};
  }, [banner_exclution_list]);

  // global and content banner data observer effect
  // useEffect(() => {
  //   log('--------------------global available');
  //   if (global_banner_main_data && typeof global_banner_main_data == 'object') {
  //     switch (position) {
  //       case bannerLocalConstant.BANNER_POSITION_LIST:
  //         if (global_banner_main_data?.list_banner_data?.length > 0) {
  //           log('hhiiihiiii');
  //           set_banner_play_data([...new Set([...global_banner_main_data.list_banner_data])]);
  //         }
  //         break;
  //       default:
  //         //bannerUtils.log("no banner data found ")
  //         break;
  //     }
  //   } else {
  //     // set_banner_setting("0x0")
  //     //console.log('--------------------global not available ')
  //   }
  //   return () => {};
  // }, [global_banner_main_data]); //

  useEffect(() => {
    if (
      content_id &&
      content_id != 0 &&
      content_fetch_status &&
      content_banner_main_data &&
      typeof content_banner_main_data == 'object'
    ) {
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_LIST:
          if (content_banner_main_data.list_banner_data) {
            set_banner_play_data([...new Set([...content_banner_main_data.list_banner_data])]);
          }
          break;
        default:
          bannerUtils.log('no banner data found ');
          break;
      }
      // break data_extract_condition;
    } else if (
      (!content_id || content_id == 0) &&
      !content_fetch_status &&
      !content_banner_main_data &&
      global_banner_main_data &&
      typeof global_banner_main_data == 'object'
    ) {
      //console.log('--------------------global available ');
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_LIST:
          if (global_banner_main_data.list_banner_data) {
            set_banner_play_data([...new Set([...global_banner_main_data.list_banner_data])]);
          }
          break;

        default:
          bannerUtils.log('no banner data found ');
          break;
      }
    } else if (
      content_id &&
      content_id != 0 &&
      content_fetch_status &&
      !content_banner_main_data &&
      global_banner_main_data &&
      typeof global_banner_main_data == 'object'
    ) {
      //console.log('--------------------global available ');
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_LIST:
          if (global_banner_main_data.list_banner_data) {
            set_banner_play_data([...new Set([...global_banner_main_data.list_banner_data])]);
          }
          break;

        default:
          bannerUtils.log('no global banner data found ');
          break;
      }
    } else {
    }
  }, [global_banner_main_data, content_banner_main_data, content_fetch_status]);

  // banner play data observer
  useEffect(() => {
    // ////alert("banner play data " + JSON.stringify(banner_play_data))
    banner_play_data?.length > 0 && filterBannerData();
    return () => {
      // set_top_banner_playing_index(-1)
    };
  }, [banner_play_data]);

  // banner settings data observer
  useEffect(() => {
    banner_settings_data?.length > 0 && setBannerSettings(banner_settings_data, position);
  }, [banner_settings_data, position]);

  const filterSettingsJsonByPosition = (data = [], matching_value = '') => {
    return data.filter((x) => x.position == matching_value && x.status === '3');
  };
  const setBannerSettings = (_banner_settings_data, _position) => {
    let temp_banner_settings_data = _banner_settings_data;

    let module_settings = filterSettingsJsonByPosition(temp_banner_settings_data, _position);

    if (module_settings?.length > 0) {
      module_settings = bannerUtils.getSettingByModule(module_settings, page_name);

      if (isMobile) {
        module_settings?.length > 0 && set_banner_setting(module_settings[0].mobile);
      } else {
        module_settings?.length > 0 && set_banner_setting(module_settings[0].desktop);
      }
    }
  };

  function filterBannerData() {
    log('filtering--------');
    if (!banner_position) {
      throw new Error(
        'Banner Item Must Have a valid position (eg: top,side-top,bottom,side-bottom)'
      );
    }
    if (!page_name) {
      throw new Error('Banner Item Must Have a valid page_name');
    }

    let temp_top_banner_data = banner_play_data;

    set_top_banner_data(temp_top_banner_data);
    const temp_banner_data = {
      top_banner_floating_data: [],
      top_banner_filler_data: [],
      top_banner_fixed_data: []
    };

    if (temp_top_banner_data?.length > 0) {
      temp_banner_data.top_banner_floating_data = bannerUtils.filterJsonByTargetType(
        temp_top_banner_data,
        TARGET_TYPE_FLOATING
      );

      temp_banner_data.top_banner_filler_data = bannerUtils.filterJsonByTargetType(
        temp_top_banner_data,
        TARGET_TYPE_FILLER
      );

      // if (content_id && content_id != 0) {
      //   temp_banner_data.top_banner_fixed_data = bannerUtils.filterJsonByTargetType(
      //     temp_top_banner_data,
      //     TARGET_TYPE_FIXED
      //   );
      // }

      set_separate_data(temp_banner_data);
    } else {
      bannerUtils.log('no Priority /////////');
    }
    setPriorityList(temp_banner_data);
  }

  const recordAnalytics = (record_type = '', _item = [], _index = 0, _video_duration = 0) => {
    const temp_session_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA)
      ? JSON.parse(sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA))
      : '';

    if (_item && _item?.length > 0 && _index >= 0 && _video_duration > 0) {
      const temp_reporting_data = bannerUtils.getBannerReportFormat();
      temp_reporting_data.type = type;
      temp_reporting_data.type_id = content_id;
      temp_reporting_data.banner_user = banner_user;
      temp_reporting_data.timestamp_get =
        temp_session_data && temp_session_data.get_timestamp ? temp_session_data.get_timestamp : 0;
      temp_reporting_data.campaign_id = _item[_index]?.campaign_id;
      temp_reporting_data.creative_id = temp_creative_id ?? 0;
      temp_reporting_data.position = _item[_index]?.position;
      temp_reporting_data.os = platform_name;

      const tempCurrentTime = dayjs(new Date()).subtract(_video_duration, 'second');
      temp_reporting_data.start_time = dayjs(tempCurrentTime).format(
        bannerLocalConstant.BANNER_DATE_FORMAT
      );

      temp_reporting_data.end_time = bannerUtils.getCurrentTime();
      temp_reporting_data.duration = _video_duration;

      let temp_banner_report = sessionStorage.getItem('banner_report')
        ? JSON.parse(sessionStorage.getItem('banner_report'))
        : '';

      // console.table(temp_banner_report)
      if (record_type == 'unmount' && temp_banner_report) {
        temp_banner_report = [...temp_banner_report, temp_reporting_data];
        sessionStorage.setItem('banner_report', JSON.stringify(temp_banner_report));
      }
    } else {
      //console.log("inside else")
    }
  };

  function getBannerPlayItem(params_separate_data) {
    let temp_banner_item = [];
    if (params_separate_data.top_banner_fixed_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_fixed_data);
    } else if (params_separate_data.top_banner_floating_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(
        params_separate_data.top_banner_floating_data
      );
    } else if (params_separate_data.top_banner_filler_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_filler_data);
    }
    return temp_banner_item;
  }

  function setPriorityList(params_separate_data) {
    log('banner::', 'setPriority----------------');
    temp_creative_id = 0;
    let temp_banner_item = [];
    if (params_separate_data.top_banner_fixed_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_fixed_data);
    } else if (params_separate_data.top_banner_floating_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(
        params_separate_data.top_banner_floating_data
      );
    } else if (params_separate_data.top_banner_filler_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_filler_data);
    } else {
    }
    if (temp_banner_item && temp_banner_item?.length > 0) {
      // if (temp_banner_item?.length == 1) {
      //   _playing_index_ref.current = 0;
      //   set_top_banner_playing_index(0);
      //   dispatch(updateBannerCardIndex(0));
      // } else if (
      //   temp_banner_item?.length > 0 &&
      //   banner_card_index_data == temp_banner_item?.length - 1
      // ) {
      //   _playing_index_ref.current = 0;
      //   set_top_banner_playing_index(0);
      //   dispatch(updateBannerCardIndex(1));
      // } else if (
      //   temp_banner_item?.length > 0 &&
      //   banner_card_index_data < temp_banner_item?.length - 1
      // ) {
      //   const nextQuee = parseInt(banner_card_index_data) + 1;
      //   _playing_index_ref.current = banner_card_index_data;
      //   set_top_banner_playing_index(banner_card_index_data);
      //   dispatch(updateBannerCardIndex(nextQuee));
      // }

      if (
        temp_banner_item?.length > 0 &&
        banner_card_index_data >= 0 &&
        banner_card_index_data < temp_banner_item?.length
      ) {
        const nextQuee = parseInt(banner_card_index_data) + 1;
        _playing_index_ref.current = banner_card_index_data;
        set_top_banner_playing_index(banner_card_index_data);

        if (nextQuee == temp_banner_item?.length) {
          dispatch(updateBannerCardIndex(0));
        } else {
          dispatch(updateBannerCardIndex(nextQuee));
        }
      } else {
        // alert('else priority');
        // console.table(temp_banner_item);
        // console.log(temp_banner_item?.length + '::' + banner_card_index_data);
        if (temp_banner_item?.length >= 2) {
          // alert('nest if priority');
          _playing_index_ref.current = 0;
          set_top_banner_playing_index(0);
          dispatch(updateBannerCardIndex(1));
        } else {
          // alert('nest else priority');
          _playing_index_ref.current = -1;
          set_top_banner_playing_index(-1);
          set_top_banner_playing_item([]);
          dispatch(updateBannerCardIndex(0));
        }
      }

      let previous_item_length = temp_banner_item?.length ?? 0;
      let previous_banner_type = temp_banner_item[_playing_index_ref.current]?.target_type ?? '';
      if (
        temp_banner_item?.length > 0 &&
        temp_banner_item[_playing_index_ref.current]?.target_type != TARGET_TYPE_FILLER
      ) {
        temp_banner_item = removeElemIfCriteriaMatched(temp_banner_item);
      }
      temp_banner_item = removeElemByBannerSettings(temp_banner_item);
      //console.log(previous_item_length + "<after>" + temp_banner_item?.length)

      // if (
      //   previous_banner_type != TARGET_TYPE_FILLER &&
      //   previous_item_length > 0 &&
      //   temp_banner_item?.length <= 0
      // ) {
      //   let _separate_data = params_separate_data;
      //   //console.log("<recursion>" + JSON.stringify(_separate_data))

      //   if (previous_banner_type == TARGET_TYPE_FIXED) {
      //     _separate_data.top_banner_fixed_data = temp_banner_item;
      //   } else if (previous_banner_type == TARGET_TYPE_FLOATING) {
      //     _separate_data.top_banner_floating_data = temp_banner_item;
      //   } else if (previous_banner_type == TARGET_TYPE_FILLER) {
      //     _separate_data.top_banner_filler_data = temp_banner_item;
      //   }
      //   set_separate_data(_separate_data);
      //   setPriorityList(_separate_data);
      // } else {
      //console.log(previous_item_length + "<seting up>" + temp_banner_item?.length)

      log('banner log--------------------');

      if (
        (_search(temp_banner_item[_playing_index_ref?.current]?.items, banner_setting)?.length >
          0 &&
          _search(temp_banner_item[_playing_index_ref?.current]?.items, banner_setting)[0]?.type ==
            'image') ||
        _search(temp_banner_item[_playing_index_ref.current]?.items, banner_setting)[0]?.type ==
          'video'
      ) {
        set_top_banner_playing_item([]);
        _playing_item_ref.current = temp_banner_item ?? [];
        set_top_banner_playing_item(temp_banner_item ?? []);
      } else {
        _playing_item_ref.current = [];
        set_top_banner_playing_item([]);
      }
      // }

      // console.log(`${temp_banner_item?.length}::banner index::${banner_card_index_data}`);
      //  videoPlay = true;
    } else {
      // set_banner_setting("0x0")
    }
  }

  const removeElemIfCriteriaMatched = (arr = []) => {
    // max_view_per_user_campaign >= max_view_per_campaign ||
    console.log('citeria');
    const _index = arr.findIndex(
      ({
        max_view_per_session,
        max_view_per_user_campaign,
        bal_view_per_user_per_camp,
        max_view_per_campaign,
        total_view_done_per_day_campaign,
        view_per_day
      }) => {
        console.group('removed data');
        console.table(arr);

        console.groupEnd('removed data');
        return (
          max_view_per_session <= 0 || bal_view_per_user_per_camp <= 0
          // || total_view_done_per_day_campaign >= view_per_day || view_per_day < 0
        );
      }
    );
    if (_index >= 0) {
      console.group('removed data selected');
      console.log(_index);

      console.groupEnd('removed data selected');
      arr.splice(_index, 1);
      removeElemIfCriteriaMatched(arr);
    }
    // else {
    // console.log('else' + _index);
    // console.table(arr);
    return arr;
    // }
  };

  const removeElemByBannerSettings = (arr = []) => {
    let filtered_arr_data = [];
    arr.map((key, ind) => {
      const { items } = key;
      if (items?.length > 0 && _search(items, banner_setting)?.length > 0) {
        filtered_arr_data.push(key);
      }
    });
    return filtered_arr_data;
  };

  const onBannerChange = () => {
    //console.log("banner changed")
    try {
      // recordAnalytics(top_banner_playing_item, top_banner_playing_index, _video_duration_ref)
      const temp_session_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA)
        ? JSON.parse(sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA))
        : '';

      const temp_reporting_data = bannerUtils.getBannerReportFormat();
      temp_reporting_data.type = type;
      temp_reporting_data.type_id = content_id;
      temp_reporting_data.banner_user = banner_user;
      temp_reporting_data.timestamp_get =
        temp_session_data && temp_session_data?.get_timestamp ? temp_session_data.get_timestamp : 0;
      temp_reporting_data.campaign_id =
        top_banner_playing_item[top_banner_playing_index]?.campaign_id ?? '';
      temp_reporting_data.creative_id = temp_creative_id ?? '';
      temp_reporting_data.position = top_banner_playing_item[top_banner_playing_index]?.position;
      temp_reporting_data.os = platform_name;

      const tempCurrentTime = dayjs(new Date()).subtract(_video_duration_ref.current, 'second');
      temp_reporting_data.start_time = dayjs(tempCurrentTime).format(
        bannerLocalConstant.BANNER_DATE_FORMAT
      );
      temp_reporting_data.end_time = bannerUtils.getCurrentTime();

      if (
        top_banner_playing_item[top_banner_playing_index]?.items[0].type == 'image' &&
        top_banner_playing_index >= 0
      ) {
        temp_reporting_data.duration = _video_duration_ref.current;
      } else {
        temp_reporting_data.duration = _video_duration_ref.current;
      }

      // video_duration = 0;
      // dispatch(updateReportData(temp_reporting_data))
      if (
        temp_reporting_data &&
        temp_reporting_data.campaign_id &&
        temp_reporting_data.creative_id
      ) {
        dispatch(updateReportData(temp_reporting_data));
      }

      //bannerUtils.log("end of func......................." + JSON.stringify(temp_reporting_data))
    } catch (error) {
      console.log(error);
    }
    if (separate_data.top_banner_fixed_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FIXED);
    } else if (separate_data.top_banner_floating_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FLOATING);
    } else if (separate_data.top_banner_filler_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FILLER);
    } else {
      bannerUtils.log('no top banner data found /////////' + JSON.stringify(separate_data));
    }
  };

  const calculateMaxViewPerSession = (type = '') => {
    let temp_banner_data = top_banner_playing_item;
    if (top_banner_playing_index >= 0 && temp_banner_data?.length > 0) {
      calculation_condition: if (
        temp_banner_data[top_banner_playing_index]?.target_type == TARGET_TYPE_FILLER
      ) {
        // alert("filler");
        break calculation_condition;
      } else if (
        temp_banner_data[top_banner_playing_index]?.max_view_per_session &&
        parseInt(temp_banner_data[top_banner_playing_index]?.max_view_per_session) > 0 &&
        temp_banner_data[top_banner_playing_index]?.view_per_day &&
        parseInt(temp_banner_data[top_banner_playing_index]?.view_per_day) > 0
      ) {
        // alert("cal")
        temp_banner_data[top_banner_playing_index].total_view_done_per_day_campaign =
          parseInt(temp_banner_data[top_banner_playing_index].total_view_done_per_day_campaign) + 1;
        /** optimization start */
        // temp_banner_data[top_banner_playing_index].max_view_per_user_campaign =
        //   parseInt(temp_banner_data[top_banner_playing_index].max_view_per_user_campaign) + 1;
        /** optimization end */
        temp_banner_data[top_banner_playing_index].bal_view_per_user_per_camp =
          parseInt(temp_banner_data[top_banner_playing_index].bal_view_per_user_per_camp) - 1;

        temp_banner_data[top_banner_playing_index].view_per_day =
          parseInt(temp_banner_data[top_banner_playing_index].view_per_day) - 1;
        temp_banner_data[top_banner_playing_index].max_view_per_session =
          parseInt(temp_banner_data[top_banner_playing_index].max_view_per_session) - 1;
      } else {
        // alert("removing")
        try {
          temp_banner_data?.splice(top_banner_playing_index, 1);
        } catch (error) {
          ////console.log(error)
        }
      }

      let temp_separate_data = '';
      temp_separate_data = separate_data;

      switch (type) {
        case TARGET_TYPE_FIXED:
          temp_separate_data.top_banner_fixed_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        case TARGET_TYPE_FILLER:
          temp_separate_data.top_banner_filler_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        case TARGET_TYPE_FLOATING:
          temp_separate_data.top_banner_floating_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        default:
          //bannerUtils.log("type null")
          break;
      }

      let temp_local_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA);
      temp_local_data = temp_local_data ? JSON.parse(temp_local_data) : '';

      // //console.group("data sync with local")
      if (
        typeof temp_local_data == 'object' &&
        typeof temp_local_data.global_banner_data == 'object'
      ) {
        switch (position) {
          case bannerLocalConstant.BANNER_POSITION_TOP:
            temp_local_data.global_banner_data.top_banner_data = [
              ...temp_separate_data.top_banner_fixed_data,
              ...temp_separate_data.top_banner_floating_data,
              ...temp_separate_data.top_banner_filler_data
            ];
            break;
          case bannerLocalConstant.BANNER_POSITION_SIDE_TOP:
            temp_local_data.global_banner_data.side_top_banner_data = [
              ...temp_separate_data.top_banner_fixed_data,
              ...temp_separate_data.top_banner_floating_data,
              ...temp_separate_data.top_banner_filler_data
            ];
            break;
          case bannerLocalConstant.BANNER_POSITION_BOTTOM:
            temp_local_data.global_banner_data.bottom_banner_data = [
              ...temp_separate_data.top_banner_fixed_data,
              ...temp_separate_data.top_banner_floating_data,
              ...temp_separate_data.top_banner_filler_data
            ];
            break;
          case bannerLocalConstant.BANNER_POSITION_SIDE_BOTTOM:
            temp_local_data.global_banner_data.side_bottom_banner_data = [
              ...temp_separate_data.top_banner_fixed_data,
              ...temp_separate_data.top_banner_floating_data,
              ...temp_separate_data.top_banner_filler_data
            ];
            break;
          case bannerLocalConstant.BANNER_POSITION_LIST:
            temp_local_data.global_banner_data.list_banner_data = [
              ...temp_separate_data.top_banner_fixed_data,
              ...temp_separate_data.top_banner_floating_data,
              ...temp_separate_data.top_banner_filler_data
            ];
            break;
          case bannerLocalConstant.BANNER_POSITION_SECTION_HEADER:
            temp_local_data.global_banner_data.section_header_banner_data = [
              ...temp_separate_data.top_banner_fixed_data,
              ...temp_separate_data.top_banner_floating_data,
              ...temp_separate_data.top_banner_filler_data
            ];
            break;
          default:
            break;
        }

        sessionStorage.setItem(
          bannerLocalConstant.GLOBAL_BANNER_DATA,
          JSON.stringify(temp_local_data)
        );
      } else {
        // //bannerUtils.log("not set on local")
      }

      // setPriorityList(temp_separate_data);
      set_separate_data(temp_separate_data);
      const previous_data_length = top_banner_playing_item?.length;

      let temp_item = [];
      if (top_banner_playing_item[top_banner_playing_index]?.target_type != TARGET_TYPE_FILLER) {
        temp_item = removeElemIfCriteriaMatched(top_banner_playing_item);
      } else {
        temp_item = top_banner_playing_item;
      }
      const current_item_length = temp_item?.length;
      if (previous_data_length == current_item_length) {
        set_top_banner_playing_item([]);
        set_top_banner_playing_item(temp_item);
      } else {
        console.log(previous_data_length + 'no data' + current_item_length);
      }
    } else {
      bannerUtils.log('banner data----------------');
    }
    // //bannerUtils.log("exit done ")
  };

  const onBannerClick = (data = [], ind = '') => {
    // //alert("cta" + data[ind].items[0].CTA)
    if (!data || data?.length < 0 || ind < 0) return false;
    let temp_click_report = {
      campaign_id: data[ind]?.campaign_id ? data[ind].campaign_id : 0,
      content_type: page_name ? page_name : 'not found',
      content_type_id: content_id,
      banner_position: position,
      creative_id: temp_creative_id ?? 0
    };
    dispatch(
      addBannerClickReport(temp_click_report, (response) => {
        //console.log("click report added")
      })
    );
    if (data[ind]?.is_consent && data[ind]?.is_consent == 1) {
      //dispatch actions to set modal open and set the consent text
      toggleConsentModal(true);
      setConsentText(data[ind]?.consent_value);

      return false;
    }
    if (data?.length > 0 && data[ind]?.items[0]?.CTA) {
      console.log('banner data click' + data[ind]?.items[0]?.CTA);
      switch (data[ind]?.items[0]?.CTA) {
        case 'external_url':
          //console.log("this is external")
          if (data[ind]?.items[0]?.external_URL) {
            bannerUtils.openNewTab(data[ind]?.items[0]?.external_URL, _TARGET_BLANK);
          }
          break;
        case 'internal_url':
          //console.log("this is internal")
          if (data[ind]?.items[0]?.internal_type) {
            if (
              data[ind]?.items[0]?.internal_type_id &&
              data[ind]?.items[0]?.internal_type_id != 0
            ) {
              redirectTo(data[ind]?.items[0]?.internal_type, data[ind]?.items[0]?.internal_type_id);
            } else {
              redirectTo(data[ind]?.items[0]?.internal_type);
            }
          }
          break;
        case 'file_download':
          //console.log("this is file download")
          if (data[ind]?.items[0]?.CTAupload_file) {
            downloadFromUrl(data[ind]?.items[0]?.CTAupload_file);
          }
          break;
        case 'pdf_open':
          //console.log("this is pdf open   ")
          if (data[ind]?.items[0]?.CTAupload_file) {
            bannerUtils.openNewTab(data[ind]?.items[0]?.CTAupload_file, _TARGET_BLANK);
            // set_cta_url(data[ind].CTAupload_file);
            // set_cta_target(_TARGET_BLANK)
          }
          break;
        default:
          ////console.log("no cta found-----☹☹😲")
          break;
      }
    } else {
      return false;
    }
  };

  const downloadFromUrl = (remote_url = '') => {
    fetch(remote_url).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = 'clirnet_file';
        a.click();
      });
    });
  };

  function _search(arr = [], term = '', type = '') {
    return arr.filter((key) => key.creative_dimension == term);
  }

  // let _playing_item = () => top_banner_playing_item?.length > 0 &&
  //     top_banner_playing_index > 0 ?
  //     _search(top_banner_playing_item[top_banner_playing_index].items, banner_setting, "playing item") : [];

  // const creative_dimention = banner_setting && is_banner_allowed && _search(top_banner_playing_item[top_banner_playing_index].items, banner_setting)?.length > 0 ? banner_setting.split('x') : [0, 0];
  // console.table(top_banner_playing_item)

  const setCreativeId = () => {
    temp_creative_id =
      _search(top_banner_playing_item[top_banner_playing_index]?.items, banner_setting)?.length >
        0 &&
      _search(top_banner_playing_item[top_banner_playing_index]?.items, banner_setting)[0]
        .creative_id;
  };

  const setBannerStyle = (_height, _width) => {
    if (_height > 0 && _width > 0 && window_width > 0) {
      let auto_height = window_width * (_height / _width);
      return { height: `${auto_height}px`, width: `100%`, cursor: 'pointer' };
    } else {
      return { height: `0px`, width: `0px`, cursor: 'pointer' };
    }
  };
  // { height: `${banner_setting.split('x')[1]}px`, width: `${banner_setting.split('x')[0]}px`, cursor: 'pointer' }

  const getBannerClass = () => {
    let tempClass = '';
    if (
      banner_setting &&
      is_banner_allowed &&
      top_banner_playing_index >= 0 &&
      top_banner_playing_item?.length > 0 &&
      _search(top_banner_playing_item[top_banner_playing_index]?.items, banner_setting)?.length > 0
    ) {
      if (position == 'top') {
        tempClass = 'mt-md-3 mb-md-3 mb-4';
      } else if (position == 'bottom') {
        tempClass = 'mt-md-3 mb-md-3 mb-4 mt-4';
      } else if (position == 'side-top') {
        tempClass = 'mb-md-3 mb-4';
      } else if (position == 'side-bottom') {
        tempClass = 'mb-md-3 mb-4';
      }
    }
    return tempClass;
  };

  function getModifiedImageUrl() {
    let url = _search(top_banner_playing_item[top_banner_playing_index]?.items, banner_setting)[0]
      .file;

    let transformation = ''; //`?tr=pr=true,c-at_max`;
    // console.log('inside video banner player', transformation, url);
    if (url && typeof url == 'string' && !url.includes('https')) {
      let splittedImg = url?.split('/');
      let path_extracted_image = splittedImg[splittedImg?.length - 1];
      const cfImageUrl = `https://bnr-cdn.clirnet.com/${path_extracted_image}${transformation}`;
      // console.log('inside video banner player in if', path_extracted_image, cfImageUrl);
      return cfImageUrl;
    } else if (
      url &&
      typeof url == 'string' &&
      url.includes('https://storage.googleapis.com/medwiki')
    ) {
      const temp_image_name = url.replace('https://storage.googleapis.com/medwiki/', '');
      const cfImageUrl = `https://bnr-cdn.clirnet.com/${temp_image_name}${transformation}`;
      // console.log('inside video banner player in else if', temp_image_name, cfImageUrl);
      return cfImageUrl;
    } else {
      // console.log('inside video banner player in else ', url);
      return url;
    }
  }

  const setBannerContainerClass = () => {
    // {position == "top" || position == "bottom" ? `w-100 text-center ${getBannerClass()}` : `w-100 text-center ${getBannerClass()}`}
    if (position == 'top') {
      return `d-inline-block position-relative text-right banner_size_adjust`;
    } else if (position == 'bottom') {
      return `d-inline-block position-relative  mt-3 text-right banner_size_adjust`;
    } else if (position == 'side-top') {
      return `d-inline-block position-relative  mt-3 text-right`;
    } else if (position == 'side-bottom') {
      return `d-inline-block position-relative  mt-3 text-right`;
    } else {
      return '';
    }
  };
  const onAgreeConsent = () => {
    // alert('agree');
    let data = top_banner_playing_item;
    let ind = top_banner_playing_index;
    console.log('data_ind', data, ind);
    if (!data || data?.length < 0 || ind < 0) return false;

    let campaign_id = data[ind]?.campaign_id ? data[ind]?.campaign_id : 0;
    let mobile_primary = userDetails()?.mobile_primary ? userDetails()?.mobile_primary : '';
    let device_details = getClientDeviceDetails(mobile_primary);

    dispatch(
      addBannerConsentClickReport(
        parseInt(campaign_id),
        JSON.stringify(device_details),
        (response) => {
          ////console.log("consent report added")
          toggleConsentModal(false);
        }
      )
    );
    if (data?.length > 0 && data[ind]?.items[0]?.CTA) {
      console.log('banner data click' + data[ind].items[0].CTA);
      switch (data[ind]?.items[0]?.CTA) {
        case 'external_url':
          ////console.log("this is external")
          if (data[ind]?.items[0]?.external_URL) {
            bannerUtils.openNewTab(data[ind]?.items[0].external_URL, _TARGET_BLANK);
          }
          break;
        case 'internal_url':
          ////console.log("this is internal")
          if (data[ind]?.items[0]?.internal_type) {
            let redirectUrl = '';
            if (
              data[ind]?.items[0]?.internal_type_id &&
              data[ind]?.items[0]?.internal_type_id != 0
            ) {
              redirectTo(data[ind]?.items[0]?.internal_type, data[ind]?.items[0]?.internal_type_id);
            } else {
              redirectTo(data[ind]?.items[0]?.internal_type);
            }
          }
          break;
        case 'file_download':
          ////console.log("this is file download")
          if (data[ind]?.items[0]?.CTAupload_file) {
            downloadFromUrl(data[ind]?.items[0]?.CTAupload_file);
          }
          break;
        case 'pdf_open':
          ////console.log("this is pdf open   ")
          if (data[ind]?.items[0]?.CTAupload_file) {
            bannerUtils.openNewTab(data[ind]?.items[0]?.CTAupload_file, _TARGET_BLANK);
            // set_cta_url(data[ind].CTAupload_file);
            // set_cta_target(_TARGET_BLANK)
          }
          break;
        default:
          //////console.log("no cta found-----☹☹😲")
          break;
      }
    } else {
      return false;
    }
  };
  return (
    <>
      <div
        className={customClass ? customClass : 'w-100'}
        ref={topBannerContainer}
        id="banner-container"
      >
        {banner_setting &&
          is_banner_allowed &&
          top_banner_playing_index >= 0 &&
          top_banner_playing_item?.length > 0 && (
            <div className="w-100 bannerCardV1Box" ref={bannerDivObserver}>
              <div className="w-100 bannerCardV1BoxPic">
                <>
                  {banner_setting &&
                    is_banner_allowed &&
                    top_banner_playing_index >= 0 &&
                    top_banner_playing_item?.length > 0 && (
                      <div
                        style={setBannerStyle(
                          banner_setting.split('x')[1],
                          banner_setting.split('x')[0]
                        )}
                      >
                        {setCreativeId()}
                        {_search(
                          top_banner_playing_item[top_banner_playing_index]?.items,
                          banner_setting
                        )?.length > 0 &&
                          _search(
                            top_banner_playing_item[top_banner_playing_index]?.items,
                            banner_setting
                          )[0].type == 'video' && (
                            <ReactPlayer
                              ref={topBannerPlayerRef}
                              width={'100%'}
                              height={'100%'}
                              muted={true}
                              playsinline={true}
                              controls={false}
                              // loop={true}
                              playing={inView}
                              url={getModifiedImageUrl()}
                              onEnded={onBannerChange}
                              onError={(e) => console.log('onError', e)}
                              onProgress={(e) => {
                                // set_video_duration(e.playedSeconds);
                                _video_duration_ref.current = e.playedSeconds;
                              }}
                            />
                          )}
                        {_search(
                          top_banner_playing_item[top_banner_playing_index]?.items,
                          banner_setting
                        )?.length > 0 &&
                          _search(
                            top_banner_playing_item[top_banner_playing_index]?.items,
                            banner_setting
                          )[0].type == 'image' && (
                            <ImageBannerPlayer
                              className="cardBannerImage"
                              url={
                                _search(
                                  top_banner_playing_item[top_banner_playing_index]?.items,
                                  banner_setting
                                )[0].file
                              }
                              seconds={
                                top_banner_playing_item[top_banner_playing_index].duration
                                  ? top_banner_playing_item[top_banner_playing_index].duration
                                  : 2
                              }
                              playing={!inView}
                              onEnded={onBannerChange}
                              onDuration={(e) => {
                                // set_video_duration(e)
                                _video_duration_ref.current = e;
                                // //console.log("image duration " + e);
                              }}
                            />
                          )}
                      </div>
                    )}
                </>
              </div>
              <div className="w-100 bannerCrdV1Btm">
                {_search(
                  top_banner_playing_item[top_banner_playing_index]?.items,
                  banner_setting
                )[0]?.CTA_text && (
                  <div className="crdV1topPart w-100 text-start">
                    <h2 className="text-black fs-16 fw-medium">
                      {
                        _search(
                          top_banner_playing_item[top_banner_playing_index]?.items,
                          banner_setting
                        )[0]?.CTA_text
                      }
                    </h2>
                  </div>
                )}
              </div>
              {_search(top_banner_playing_item[top_banner_playing_index]?.items, banner_setting)[0]
                ?.CTA_button && (
                <div className="w-100 cardV1Ftr d-flex align-items-center justify-content-between px-3 pb-3">
                  <span>Sponsored</span>

                  {/* {top_banner_playing_item?.length}Sponsored{top_banner_playing_index} :campaign
                      id :{top_banner_playing_item[top_banner_playing_index]?.campaign_id} */}

                  <button
                    className="cardV1FtrBtn ms-2 fw-medium rippleEffect rounded cursorPointer"
                    onClick={() => onBannerClick(top_banner_playing_item, top_banner_playing_index)}
                    onMouseEnter={() => {
                      setIsHoverd(true);
                      setActiveHover(true);
                    }}
                    onMouseLeave={() => {
                      setIsHoverd(false);
                      setActiveHover(false);
                    }}
                    style={{
                      border: `${
                        isHoverd && activeHover ? '1px solid transparent' : '1px solid #355fd3'
                      }`,
                      // color: `${isHoverd && activeHover ? '#fff' : cardData?.color ?? '#22a5f8'}`,
                      backgroundColor: `${isHoverd && activeHover ? '#355fd3' : 'transparent'}`
                    }}
                  >
                    {/* <div className="cardV1BtnHover" style={{ backgroundColor: '#355fd3' }}></div>
                    <div
                      className="cardV1BtnBorder rounded"
                      style={{ borderColor: '#355fd3' }}
                    ></div> */}
                    <span
                      style={{
                        color: `${isHoverd && activeHover ? '#fff' : '#355fd3'}`
                      }}
                      className="d-flex align-items-center gap-1"
                    >
                      {
                        _search(
                          top_banner_playing_item[top_banner_playing_index]?.items,
                          banner_setting
                        )[0].CTA_button
                      }
                      <i className="flaticon-next fs-4 ms-2"></i>
                      {/* <svg strokeWidth="0" viewBox="0 0 24 24" class="fs-2 fs-2 ms-2">
                        <path
                          d="M23.0677 11.9929L18.818 7.75739L17.4061 9.17398L19.2415 11.0032L0.932469 11.0012L0.932251 13.0012L19.2369 13.0032L17.4155 14.8308L18.8321 16.2426L23.0677 11.9929Z"
                          fill="currentColor"
                        ></path>
                      </svg> */}
                    </span>
                  </button>
                </div>
              )}
            </div>
          )}
      </div>
      <ConsentModal
        title="Terms & Conditions"
        is_consent_modal={is_consent_modal}
        consent_text={consent_text}
        onHide={() => toggleConsentModal(false)}
        onAgreeConsent={onAgreeConsent}
      />
    </>
  );
};

BannerItemCard.propTypes = {
  position: PropTypes.string.isRequired,
  page_name: PropTypes.string.isRequired
};

export default BannerItemCard;
